{
  "common": {
    "save": "Zapisz",
    "cancel": "Anuluj",
    "delete": "Usuń",
    "edit": "Edytuj",
    "search": "Szukaj",
    "loading": "Ładowanie...",
    "yes": "Tak",
    "no": "Nie",
    "language": "Język",
    "settings": "Ustawienia",
    "logout": "Wyloguj się",
    "today": "Dziś",
    "yesterday": "Wczoraj",
    "saved": "Zapisano"
  },
  "sidebar": {
    "dashboard": "Przegląd",
    "newOrder": "Nowe zamówienie",
    "kitchen": "Kuchnia",
    "restaurant": "Restauracja",
    "products": "Produkty",
    "employees": "Pracownicy"
  },
  "profile": {
    "title": "Mój profil",
    "firstName": "Imię",
    "lastName": "Nazwisko"
  },
  "attendance": {
    "arrive": "Przyjście",
    "leave": "Wyjście"
  }
}
